import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TmsWebBaseEditService } from '../base';
import { FieldLabel } from '../../models';
import { TmsWebTranslationService } from '../translation/tms-web-translation.service';

@Injectable({
  providedIn: 'root',
})
// Customer-configurable field labels (weaving plan WS10). Screens that use
// configurable captions call load() before building their fields, then resolve
// each caption with label(fieldKey, fallback) - the chosen synonym is run
// through translateFieldLabel so it still translates per language.
export class FieldLabelService extends TmsWebBaseEditService<FieldLabel, FieldLabel> {
  private readonly tmsWebTranslationService = inject(TmsWebTranslationService);

  private labels = new Map<string, string>();

  constructor() {
    super('FieldLabel', $localize`Field Label`);
  }

  load(): Observable<FieldLabel[]> {
    return this.all().pipe(tap((labels) => (this.labels = new Map(labels.map((x) => [x.fieldKey, x.selectedLabel])))));
  }

  all(): Observable<FieldLabel[]> {
    return this.httpService.get<FieldLabel[]>(`${this.apiUrl}/All`);
  }

  label(fieldKey: string, fallback: string): string {
    const selected = this.labels.get(fieldKey);
    return selected ? this.tmsWebTranslationService.translateFieldLabel(selected) : fallback;
  }
}
